import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, Video, ChevronRight, CalendarPlus, Inbox } from "lucide-react";

export const UpcomingSession = () => {
  // Les réservations ne sont pas encore ouvertes : rien à afficher tant que
  // le parcours de paiement n'existe pas côté serveur.
  const booking = null;
  if (!booking?.coach) {
    return <section className="upcoming-session" data-testid="upcoming-session">
      <div className="section-heading"><h2>Prochaine séance</h2></div>
      <div className="empty-state" data-testid="upcoming-session-empty">
        <CalendarPlus size={22} />
        <p>Aucune séance planifiée.</p>
        <Link to="/coach" data-testid="upcoming-session-book" className="button button-outline">Réserver une séance</Link>
      </div>
    </section>;
  }
  const coach = booking.coach;
  return <section className="upcoming-session" data-testid="upcoming-session">
    <div className="section-heading"><h2>Prochaine séance</h2><span className="status-badge">Prévue</span></div>
    <div className="session-date"><CalendarDays size={15} /><span>{`${booking.date} · ${booking.slot}`}</span></div>
    <div className="upcoming-coach">
      {coach.avatar && <img src={coach.avatar} alt={coach.name} />}
      <div><strong>{coach.name?.split("'")[1] || coach.name}</strong><span>{coach.rank}</span></div>
    </div>
    <h3>{booking.offer?.title || "Séance de coaching"}</h3>
    <p><Video size={13} />Coaching individuel <span>·</span> {booking.offer?.duration || 60} min</p>
    <Link to="/sessions" data-testid="upcoming-session-details" className="subtle-link">Voir mes séances <ArrowRight size={13} /></Link>
  </section>;
};

export const SessionHistory = ({ full = false }) => <section className="history-section">
  <div className="section-heading">
    <h2>{full ? "Historique des séances" : "Dernières séances"}</h2>
    {!full && <Link to="/sessions" data-testid="all-sessions-link">Tout voir <ArrowRight size={14} /></Link>}
  </div>
  <div className="session-table" role="table" aria-label="Séances récentes">
    <div className="session-table-header" role="row"><span>Séance</span><span>Coach</span><span>Date</span><span>Statut</span><span /></div>
    <div className="empty-state empty-row" data-testid="session-history-empty">
      <Inbox size={22} />
      <p>Aucune séance pour le moment.</p>
    </div>
  </div>
</section>;
